//LIBRARIES
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

//COMPONENTS
import TextButton from 'components/ui/Buttons/TextButton';
import PillButton from 'components/ui/Buttons/PillButton';
import Spacer from 'components/ui/Spacer';

//ACTIONS
import { sendInvitation, sendPasswordReset } from 'actions/landlordUserActions';

//HELPERS
import { getTranslatedString } from 'helpers/i18n';
import { deepDiver } from 'helpers/utilities';

const Button = styled(TextButton)`
  padding: 0;
`;

const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const showAccountActionButtons = user => {
  if (!user.providerIsSSO) return true;
  if (user.user_type === 'Maintenance') {
    return true;
  }
  return false;
};

const DeactivateButton = ({ isDeactivated, toggleConfirmationDialog }) => {
  return (
    <Button onClick={toggleConfirmationDialog}>
      {isDeactivated
        ? getTranslatedString('landlordPortal.userForm.reactivateUser')
        : getTranslatedString('landlordPortal.userForm.deactivateUser')}
    </Button>
  );
};

const InviteAndResetPasswordButtons = ({ user, sendInvitation, sendPasswordReset }) => {
  return (
    <Fragment>
      {(user.status === 'Invited' || user.status === 'Not Invited') && (
        <PillButton
          onClick={() => {
            sendInvitation(user.user_type, user.user_id);
          }}
        >
          {getTranslatedString('landlordPortal.users.userDetailsOverview.reInvite')}
        </PillButton>
      )}

      {user.status === 'Confirmed' && (
        <PillButton
          onClick={() => {
            sendPasswordReset(user.user_type, user.user_id);
          }}
        >
          {getTranslatedString('landlordPortal.users.userDetailsOverview.sendPasswordReset')}
        </PillButton>
      )}
    </Fragment>
  );
};

const DeactivateAndPasswordReset = ({
  user,
  loggedInUser,
  toggleConfirmationDialog,
  sendPasswordReset,
  sendInvitation,
}) => {
  if (!user) return null;
  if (!loggedInUser.admin) return null;
  const isUserLoggedInAgent =
    user.user_type.toLowerCase() === loggedInUser.userType.toLowerCase() &&
    user.user_id === loggedInUser.userId;
  const showInviteAndPasswordResetButtons = showAccountActionButtons(user);

  return (
    <Fragment>
      <Spacer mb={1} mt={2}>
        <StyledButtonContainer>
          {!isUserLoggedInAgent && (
            <DeactivateButton
              isDeactivated={user.status === 'Deactivated'}
              toggleConfirmationDialog={toggleConfirmationDialog}
            />
          )}
          {showInviteAndPasswordResetButtons && (
            <InviteAndResetPasswordButtons
              user={user}
              sendPasswordReset={sendPasswordReset}
              sendInvitation={sendInvitation}
            />
          )}
        </StyledButtonContainer>
      </Spacer>
    </Fragment>
  );
};

const mapStoreToProps = store => ({
  loggedInUser: deepDiver(store, 'userTypes'),
});

const mapDispatchToProps = {
  sendPasswordReset,
  sendInvitation,
};

export default connect(mapStoreToProps, mapDispatchToProps)(DeactivateAndPasswordReset);
